export * from './static-offer-paywall'
